// Как рисуется отметка на снимке: ВЕРДИКТ — цветом, СВЕДЕНИЕ — обводкой.
//
// Две величины на одной точке, и смешивать их нельзя. Вердикт говорит, что
// увидел прибор («здесь что-то есть», «это судно по следу», «это облако по
// тени»); сведение говорит, нашлось ли этому судно в АИС. Свернув их в один
// цвет, мы получили бы шкалу, по которой не прочесть ни одного из двух.
//
// КРАСНОГО У «НЕ СВЕДЕНО» НЕТ НИ В ОДНОМ СОСТОЯНИИ. Отметка без пары — это не
// нарушитель: полнота детектора не измерена, эталон GFW огрублён до часа и
// клетки 0,01°, а лаг его публикации ~96 часов — то есть у свежего снимка пары
// не будет НИ У КОГО. Тревожный цвет вынес бы вердикт, которого мы не выносим,
// и картинка утверждала бы больше, чем данные.

export type Verdict =
  | 'mark'          // радар: здесь что-то есть, и это всё
  | 'vessel'        // оптика: след за кормой
  | 'cloud'         // оптика: тень против солнца
  | 'conflict'      // оптика: и след, и тень
  | 'unconfirmed'   // оптика: улик нет — это НЕ отбраковка
  | 'obscured'      // оптика: смотрели сквозь дымку

export type AisState = 'matched' | 'unmatched' | 'not_asked'

/** Вердикты, которые УТВЕРЖДАЮТ, что отметка — судно. Радар не утверждает. */
export const CLAIMS_VESSEL: readonly Verdict[] = ['vessel']

/** Цвет отметки по вердикту. Нейтральная гамма: ни один вердикт не обвиняет. */
export function verdictColor(verdict: string): string {
  switch (verdict) {
    case 'vessel':
      return '#22d3ee'
    case 'mark':
      return '#7dd3fc'
    case 'cloud':
      return '#94a3b8'
    case 'conflict':
      return '#fbbf24'
    case 'obscured':
      return '#a78bfa'
    default:
      // `unconfirmed` и всё незнакомое — тускло, но ВИДНО: пропавшая отметка
      // неотличима от «прибор её не нашёл».
      return '#cbd5e1'
  }
}

/** Обводка по состоянию сведения: сплошная у пары, пунктир у «не спрашивали». */
export function aisStroke(state: AisState): { color: string; width: number; dash?: number[] } {
  switch (state) {
    case 'matched':
      return { color: '#f8fafc', width: 2 }
    case 'unmatched':
      // Тоньше сведённой и без цвета: «пары нет» — это отсутствие сведения, а
      // не находка. Заметнее сведённой она быть не имеет права.
      return { color: '#64748b', width: 1 }
    default:
      return { color: '#475569', width: 1, dash: [2, 2] }
  }
}

/** Состояние сведения из свойств фичи. Незнание ошибается в сторону «не спрашивали». */
export function aisState(ais: { matched?: boolean } | null | undefined): AisState {
  if (!ais) return 'not_asked'
  return ais.matched ? 'matched' : 'unmatched'
}

/** Ключ подписи вердикта. Незнакомый код показывается КАК ЕСТЬ — выдуманное
 *  имя пережило бы верификацию и осталось бы в витрине навсегда. */
export function verdictLabelKey(verdict: string): string {
  return `imagery.verdict.${verdict}`
}
